import React from "react";
import clsx from 'clsx';

/**
 * @param {[]} props.infoRow - components of specific row
 * @param {[]} props.componentsRow - type of components of specific row
 * @param {number} props.formRowIndex - index of specific row of data element
 * @returns summary with components of row of specific data element
 */
const SummaryRow = (props) => {

    const {
        infoRow,
        componentsRow,
        formRowIndex
    } = props


    return(
        <div className ={clsx('flexRowDirection')}>
            {componentsRow.map( (component, index) => 
                {
                    if(component === 'button' && infoRow[index] !== undefined){
                        return(
                            <span className={clsx('spacingLeftDiv2')} key={`SummaryRow${formRowIndex}Component${infoRow[index].label}`}>
                                <button type='button' className={clsx("btn", "btn-primary")}> {infoRow[index].label}</button>&nbsp;
                            </span>
                        )
                    }
                    if( component === 'input' && infoRow[index] !== undefined){
                        return(
                            <span className={clsx('spacingLeftDiv2')} key={`SummaryRow${formRowIndex}Component${infoRow[index].placeholder}`}>
                                <input
                                    placeholder={infoRow[index].placeholder}
                                    value=''
                                    type={infoRow[index].type}
                                    onChange={() => {}}
                                    className="form-control"
                                /> &nbsp;
                            </span>
                        )
                    }
                    if( component === 'textarea' && infoRow[index] !== undefined){
                        return(
                            <span className={clsx('spacingLeftDiv2')} key={`SummaryRow${formRowIndex}Component${infoRow[index].placeholder}`}>
                                <textarea
                                    value=''
                                    placeholder={infoRow[index].placeholder}
                                    onChange={() => {}}
                                    className="form-control"
                                />&nbsp;
                            </span> 
                        )
                    }
                    if( component === 'radio' && infoRow[index] !== undefined && infoRow[index].labels !==undefined){
                        return(
                            <span key={`SummaryRow${formRowIndex}ComponentRadio`}>
                                {infoRow[index].labels.map( (label) =>
                                    <div  key={`SummaryRow${formRowIndex}ComponentRadio${label}`} className={clsx('form-check', 'form-check-inline','spacingLeftDiv2')}>
                                        <input type="radio" id={`SummaryRow${formRowIndex}ComponentInput${label}`} name = {`Radio${label}`} onChange={() => {}} checked className={clsx('form-check-input')}/>
                                        <label htmlFor={`SummaryRow${formRowIndex}ComponentInput${label}`}  className={clsx('form-check-label')}>{label}</label>
                                    </div>
                                    )
                                }
                            </span>      
                        )
                    }
                    if( component === 'checkbox'){
                        return(
                            <span  className={clsx('spacingLeftDiv2')} key={`SummaryRow${formRowIndex}ComponentCheckbox`}>
                                <input 
                                    type='checkbox'
                                    checked= {false}
                                    style={{width: '1vw', height: '1vw',display: 'inline-block', marginTop: '0.3vw' }}
                                    onChange={() => {}}
                                />&nbsp;
                            </span>
                        )
                    }
                    if( component === 'label' && infoRow[index] !== undefined){
                        if(infoRow[index].labelName !== undefined ){
                            return (
                                <span className={clsx('spacingLeftDiv2')} key={`SummaryRow${formRowIndex}ComponentLabel`}>
                                    <label htmlFor={`SummaryRow${formRowIndex}ComponentLabel`} className="col-form-label" style={{display: 'flex', marginBottom: '0', alignItems: 'center'}}>{infoRow[index].labelName}</label>&nbsp;
                                </span> 
                            )
                        }
                        return(
                            <span className={clsx('spacingLeftDiv2')} key={`SummaryRow${formRowIndex}ComponentLabel`}>
                                <label htmlFor={`SummaryRow${formRowIndex}ComponentLabel`} className="col-form-label" style={{display: 'flex', marginBottom: '0', alignItems: 'center'}}>{infoRow[index].label}</label>&nbsp;
                            </span>
                        )
                    }
                    if(component === 'dropdown' && infoRow[index] !== undefined && infoRow[index].options !== undefined){
                        return(
                            <span className={clsx('spacingLeftDiv2')} key={`SummaryRow${formRowIndex}ComponentDropdown`}>  
                                <div className= {clsx('dropdown', 'show')}>
                                    <button className={clsx('btn',  'dropdown-toggle')} type="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {infoRow[index].label}
                                    </button>
                                    <div className={clsx('dropdown-menu')} >
                                        {infoRow[index].options.map( option => 
                                            <button type='button' className={clsx('dropdown-item')} >{option}</button>
                                        )
                                        }
                                    </div>       
                                </div>
                            </span>
                        )
                    }

                    return '';
                }
            )}
        </div>                 
    )

}

export default SummaryRow;